import { render, staticRenderFns } from "./ReportFormPersonalDataSimpleNoMail.vue?vue&type=template&id=128bde60"
import script from "./ReportFormPersonalDataSimpleNoMail.vue?vue&type=script&lang=ts"
export * from "./ReportFormPersonalDataSimpleNoMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports